<template>
  <!--文档页面，参数pageType共四种：隐私政策privacy；用户协议userAgreement；创作协议createAgreement；影像使用协议imageUserAgreement-->

  <div>
    <!--顶栏-->
    <v-app-bar app flat height="50" color="#1E3A8A">
      <v-img src="../../assets/top_bar/logoAndTitleNew.png" style="width:220px;flex:none;margin-right:14px;"></v-img>
    </v-app-bar>


    <!--文档区域-->
    <div style="height:calc(100% - 50px);margin-top:50px;padding:30px 40px;">


      <p style="text-align:center;font-size:24px;font-weight:bold;">{{pageName}}</p>

      <div class="documentArea">
        <p v-for="(item,index) in pageDocument" :key="index" v-html="item"></p>
      </div>

    </div>

  </div>


</template>

<script>
export default {
  name: "documentPage",
  data(){
    return{

      pageName:"",
      pageDocument:[],


      document_privacy:[
        "<p>隐私政策</p>",
        "<p>发布日期：2022年11月19日&nbsp;&nbsp;&nbsp;&nbsp;生效日期：2022年11月19日</p>",
        "<br />",
        "<p style='font-size:18px;font-weight:bold;'>引言</p>",
        "<p style='font-weight:bold;'>欢迎您使用长光卫星技术股份有限公司自主运营的吉林一号·共生地球(以下简称“我们”)。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们深知个人信息对您的重要性!因此，我们将严格遵守《网络安全法》、《电信和互联网用户个人信息保护规定》、《信息安全技术公共及商用服务信息系统个人信息保护指南》等法律法规的相关规定，采取相应的安全保护措施来保证您的个人信息安全。我们将通过《吉林一号·共生地球隐私政策》(以下简称“本政策”)向您说明我们会如何收集、存储、保护和使用您的信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。在阅读本政策时请注意以下几点：</p>",
        "<p style='font-weight:bold;'>1、在注册本实验室及开始使用产品与服务前，请您务必仔细阅读并理解本政策，确保您充分理解和同意后再开始使用，注册/继续使用表示您已完整阅读、理解并接受本政策；</p>",
        "<p style='font-weight:bold;'>2、您同意本政策表示您已了解本网站所提供的功能，以及在功能运行时所需要的必要个人信息，并给予相应的收集使用授权。处理敏感个人信息或用于本政策未涵盖的用途前，我们会根据您的实际使用情况单独征求您的同意；</p>",
        "<p style='font-weight:bold;'>3、我们尽量以更清晰、更易理解的方式展现本政策，以便您更容易理解。如对本政策内容有任何疑问、意见或建议，您可通过本政策文末的联系方式与我们联系。</p>",
        "<p style='font-weight:bold;'>4、如因本政策产生的任何争议，均应首先通过友好协商解决，协商不成，贵我双方均有权向本实验室所在地有管辖权的人民法院提起诉讼。本实验室所在地为吉林省长春市。</p>",

        "<p style='font-size:18px;font-weight:bold;'>如何收集您的个人信息</p>",
        "<p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。<span style='font-weight:bold;'>长光卫星依据法律法规以及遵循正当、合法、必要的原则而收集和使用您在使用服务过程中主动提供或由于产品和/或服务需要而产生的个人信息。如果我们欲将您的个人信息用于本隐私政策未载明的其它用途，或基于特定目的将收集而来的信息用于其他目的，我们会及时以合理的方式向您告知，并在使用前再次征得您的同意。</span></p>",
        "<p style='font-weight:bold;'>我们仅会出于本政策所述的以下场景中，收集和使用您的个人信息：</p>",
        "<p style='font-weight:bold;'>1.账号注册/登录</p>",
        "<p>在您注册本实验室帐号时，您需要根据注册提示，按照要求提供的您的电子邮箱作为登录账号，并提供您的邮箱登录密码，如果您通过共生地球APP客户端进行扫码注册，我们将收集并绑定您的共生地球APP账号信息至实验室账号中，包括但不限于：账号个人信息、客户端设备信息、软件操作日志等。</p>",
        "<p style='font-weight:bold;'>2.影像业务服务</p>",
        "<p>在您使用本网站的影像业务服务时，包括影像地图和影像内容浏览、搜索、收藏、分享、购买等，我们将自动接收并记录您的浏览器和计算机上的信息，包括但不限于如下信息：</p>",
        "<p><li style='float: left;'></li>设备信息：为保障服务的正常运行，我们可能会收集您的操作系统版本号、软件版本号、IP地址、设备型号、网络设备硬件地址(MAC)、唯一设备标识符(比如: IMEI、 IDFA、 Device Token)、设备识别码、网络接入方式及类型、操作日志、设备存储读写权限信息。请您了解，这些信息是我们提供服务和保障产品正常运行所必须收集的基本信息。</p>",
        "<p><li style='float: left;'></li>日志信息：为持续改进和优化我们的产品使用体验、排查产品故障，我们的服务器会自动记录您的日志信息，包括您的设备型号、操作系统、唯一设备识别码、IP地址、接入网络方式、类型和状态、服务使用记录、操作日志信息、语言及时区信息。特别希望您注意，在分享过程中请您妥善保护自己的个人信息，避免发布您的个人隐私。如您发现自己的个人信息泄露时，尤其是您的账户存在异常，请您立即联系遥感实验室官方客服，以便我们及时采取措施。</p>",
        "<p><li style='float: left;'></li>购买信息：仅当您在我们的产品和/或服务中产生购买内容行为时，我们将根据您的购买行为及购买的内容收集如下部分或全部的个人信息：购买内容、购买金额、购买时间、订单账户、订单编号、订单状态、支付方式（此功能为我们接入第三方软件开发工具包所开发的功能）、支付账号、支付状态。我们收集上述信息是为了帮助您顺利完成购买交易、保障您的交易安全、查询订单信息、提供客户服务等。</p>",
        "<p style='font-weight:bold;'>3.创作中心服务</p>",
        "<p>当您在使用本网站创作中心服务时，包括创作类型选取、创作内容编辑、创作内容发布等，我们将自动接收并记录您的浏览器和计算机上的信息，包括但不限于如下信息：</p>",
        "<p><li style='float: left;'></li>设备信息：为保障服务的正常运行，我们可能会收集您的操作系统版本号、软件版本号、IP地址、设备型号、网络设备硬件地址(MAC)、唯一设备标识符(比如: IMEI、 IDFA、 Device Token)、设备识别码、网络接入方式及类型、操作日志、设备存储读写权限信息。请您了解，这些信息是我们提供服务和保障产品正常运行所必须收集的基本信息。</p>",
        "<p><li style='float: left;'></li>日志信息：为持续改进和优化我们的产品使用体验、排查产品故障，我们的服务器会自动记录您的日志信息，包括您的设备型号、操作系统、唯一设备识别码、IP地址、接入网络方式、类型和状态、服务使用记录、操作日志信息、语言及时区信息。</p>",
        "<p><li style='float: left;'></li>第三方账号信息：当您绑定第三方账号信息，如共生地球APP客户端账号，我们会自动收集您的共生地球APP账号信息包括但不限于：账号个人信息、客户端设备信息、软件操作日志等。请您了解，这些信息是我们提供创作中心服务和保障产品正常运行所必须收集的基本信息。</p>",
        "<br />",
        "<p>关于个人敏感信息的提示：</p>",
        "<p>个人敏感信息是一旦泄露、非法提供或滥用可能危害人身和财务安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，包括生物识别、特定身份、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。相关由您提供或我们收集您的信息中，可能包含您的敏感信息，我们会采取严格和特殊加密措施保护您的个人信息，并要求合作第三方对您的个人信息进行严格保密，未经您明示授权，我们不会对外披露您的个人敏感信息或用作其他用途。<span style='font-weight:bold;'>请您谨慎并留意个人敏感信息，您同意您的个人敏感信息我们可以按照本政策所述的目的和方式来处理。</span></p>",

        "<p style='font-size:18px;font-weight:bold;'>Cookies或同类技术</p>",
        "<p>cookies和同类技术是互联网中普遍使用的技术。在您未拒绝接受cookies的情况下，我们可能通过cookies或同类技术获取和使用您的信息，包括：您访问网站的习惯、您的浏览信息、您的登录信息，cookies和同类技术收集该类信息是为了您使用我们的产品与或服务的必要、简化您重复操作的步骤（如注册、登录）、便于您查看使用历史（如影像查询历史）、向您提供更切合您个人需要的服务内容和您可能更感兴趣的内容、保护您的信息和账号安全性、提升我们的产品和服务等。</p>",
        "<p>我们不会将 cookies用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 cookies。您可以清除计算机上保存的所有 cookies，大部分网络浏览器都设有阻止 cookies的功能。如果您拒绝我们使用cookies及同类技术收集和使用您的相关信息，您可在浏览器具备该功能的前提下，通过您的浏览器的设置以管理、拒绝cookies；或删除已经储存在您的计算机、移动设备或其他装置内的cookies。您如需详细了解如何更改浏览器设置，请具体查看您使用的浏览器的相关设置页面。您理解并知悉：我们的某些产品只能通过使用cookies或同类技术才可得到实现，如您拒绝使用或删除的，您可能将无法正常使用我们的相关产品或无法通过我们的产品获得最佳的服务体验，同时也可能会对您的信息保护和账号安全性造成一定的影响。</p>",
        "<p style='font-size:18px;font-weight:bold;'>使用和披露的个人信息</p>",
        "<p>1.我们可能将在向您提供服务的过程之中所收集的信息用作下列用途: </p>",
        "<p><li style='float: left;'></li>在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；</p>",
        "<p><li style='float: left;'></li>帮助我们设计新服务，改善我们现有服务，使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如权限设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；</p>",
        "<p>2.我们不会向任何无关第三方共享您的个人信息，仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。当本网站与第三方合作伙伴共同为您提供服务时，会事先得到您明确同意。对于我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理信息。</p>",
        "<p>3.在如下情况下，本网站将依据您的个人意愿或法律的规定全部或部分地披露您的个人信息：</p>",
        "<p><li style='float: left;'></li>经您事先同意，向第三方披露；</p>",
        "<p><li style='float: left;'></li>根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您信息的情况下，向第三方或者行政、司法机构披露。</p>",

        "<p style='font-size:18px;font-weight:bold;'>数据使用过程中涉及的合作方以及转移、公开个人信息</p>",
        "<p style='font-weight:bold;'>1.数据使用过程中涉及的合作方</p>",
        "<p>1.1基本原则</p>",
        "<p style='font-weight:bold;'>我们与合作方合作过程中，将遵守以下原则：</p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>合法原则：涉及数据处理活动的，应当遵守合法原则。</span></p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>正当与最小必要原则：数据使用必须具有正当目的，且应以达成目的必要为限。</span></p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>安全审慎原则： 我们将审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。</span></p>",
        "<p>1.2委托处理</p>",
        "<p>对于委托处理个人信息的场景，我们会与受托合作方根据法律规定签署相关处理协议，并对其个人信息使用活动进行监督。</p>",
        "<p>1.3共同处理</p>",
        "<p>对于共同处理个人信息的场景，我们会与合作方根据法律规定签署相关协议并约定各自的权利和义务，确保在使用相关个人信息的过程中遵守法律的相关规定、保护数据安全。</p>",
        "<p>1.4合作方的范围</p>",
        "<p>若具体功能和场景中涉及由我们的关联方、第三方提供服务，则合作方范围包括我们的关联方与第三方。</p>",
        "<p>1.5合作方目录及数据获取权限</p>",
        "<p><table style='width:100%;text-align:center;border-collapse:collapse;table-layout: fixed; word-break: break-all; word-wrap: break-word;' border='1'>\n" +
        "<tr>\n" +
        "<td>第三方名称</td>\n" +
        "<td>SDK</td>\n" +
        "<td>使用目的</td>\n" +
        "<td>使用场景</td>\n" +
        "<td>权限说明</td>\n" +
        "<td>信息收集类型</td>\n" +
        "<td>信息收集和使用方式</td>\n" +
        "<td>隐私政策链接</td>\n" +
        "</tr>\n" +
        "<tr>\n" +
        "<td>北京百度网讯科技有限公司</td>\n" +
        "<td>百度地图开放平台SDK</td>\n" +
        "<td>用于支持根据用户IP所在地进行定位</td>\n" +
        "<td>影像地图浏览、影像创作定位</td>\n" +
        "<td>获取用户ip地址</td>\n" +
        "<td>用户的ip地址</td>\n" +
        "<td>后台接口传输</td>\n" +
        "<td>https://lbsyun.baidu.com/index.php?title=openprivacy</td>\n" +
        "</tr>\n" +
        "<tr>\n" +
        "<td>共生地球APP客户端</td>\n" +
        "<td>无</td>\n" +
        "<td>绑定遥感实验室账号，优化服务体验</td>\n" +
        "<td>绑定APP</td>\n" +
        "<td>获取用户所绑定APP账号信息</td>\n" +
        "<td>获取用户所绑定APP账号信息</td>\n" +
        "<td>后台接口传输</td>\n" +
        "<td></td>\n" +
        "</tr>\n" +
        "</table></p>",
        "<p style='font-weight:bold;'>2 运营主体变更转移</p>",
        "<p>随着业务的持续发展，我们将有可能进行合并、收购、资产转让，你的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所载明的安全标准要求继受方保护你的个人信息，继受方变更原先的处理目的、处理方式的，我们将要求继受方重新征得你的授权同意。</p>",
        "<p style='font-weight:bold;'>3 停止运营</p>",
        "<p>如果我们停止运营产品或服务，将及时停止继续收集你的个人信息。我们会逐一送达通知或以公告的形式向你发送停止运营的告知，并对我们所持有的与已关停的产品或服务相关的个人信息进行删除或匿名化处理。</p>",
        "<p style='font-weight:bold;'>4 依法豁免征得你的授权同意的情形</p>",
        "<p style='font-weight:bold;'>请你理解，在下列情形中，根据法律法规及国家标准，合作方使用，或我们转移、公开你的个人信息无需征得你的授权同意：</p>",
        "<p><li style='float: left;'></li>根据你的要求订立或履行合同所必需；</p>",
        "<p><li style='float: left;'></li>为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；</p>",
        "<p><li style='float: left;'></li>为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>",
        "<p><li style='float: left;'></li>为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>",
        "<p><li style='float: left;'></li>在合理的范围内处理你自行公开的个人信息，或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）；</p>",
        "<p><li style='float: left;'></li>法律法规规定的其他情形。</p>",

        "<p style='font-size:18px;font-weight:bold;'>我们如何存储和保护您的个人信息</p>",
        "<p style='font-weight:bold;'>1.信息存储</p>",
        "<p>1.1存储地点：我们依照法律法规的规定，仅会将收集到的有关您的个人信息存储于中华人民共和国境内。目前我们暂时不存在跨境存储您的个人信息或向境外提供个人信息的场景。如果确有必要进行数据的跨境传输，我们会单独向您明确告知（包括数据出境的目的、接收方、使用方式与范围、使用内容、安全保障措施、安全风险等），并征得您的授权同意，我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。</p>",
        "<p>1.2存储期限：我们在为您提供满足产品或服务过程中所必需且最短的期间内保留您的个人信息，例如：当您使用我们的注册功能时，我们需要收集您的电子邮箱，且在您提供后并在您使用该功能期间，我们需要持续保存您的邮箱账号，以向您正常提供该功能、保障您的账号和系统安全。此外，我们将对您的相关信息保存至相关法律所规定的必要期限（例如《电子商务法》：商品和服务信息、交易信息保存时间自交易完成之日起不少于三年）。</p>",
        "<p>1.3在超出上述存储期限后，我们会对您的个人信息进行删除或匿名化处理。</p>",
        "<p>1.4除法律法规或监管部门另有规定外，我们仅会按照上述存储地点与存储方式存储您的个人信息，以下情形除外：</p>",
        "<p><li style='float: left;'></li>法律法规有明确规定；</p>",
        "<p><li style='float: left;'></li>获得您的授权同意；</p>",
        "<p>针对以上情形，我们会确保依据国家法律法规和相关监管部门的规定执行，并对您的个人信息提供足够的保护。</p>",
        "<p style='font-weight:bold;'>2.信息保护</p>",
        "<p>2.1我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。我们同时对我们网站提供安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息。</p>",
        "<p>2.2我们会采取一切合理可行的措施，确保不收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>",
        "<p>2.3互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他我们用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</p>",
        "<p>2.4互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。同时，我们还有专业的安全技术和运营团队负责维护，便于及时有效的响应、处置各类安全漏洞和突发事件，联合相关部门进行安全事件溯源和打击。</p>",
        "<p>2.5发生或者可能发生个人信息泄露、篡改、丢失的，我们将立即采取补救措施，并第一时间通知相关部门、负责人及信息主体、监管部门。</p>",

        "<p style='font-size:18px;font-weight:bold;'>您如何管理您的个人信息</p>",
        "<p>我们鼓励您更新和修改您的个人信息以使其更准确有效。如您想查询、修改或删除您的部分信息，请前往实验室个人中心相关功能页面。若您无法通过上述方式访问或修改您的个人信息，可以通过本政策“如何联系我们”章节所列的反馈渠道联系我们为您处理。</p>",
        "<p>在以下情形中，我们将无法响应您的信息修改请求：</p>",
        "<p><li style='float: left;'></li>与我们履行法律法规规定的义务相关的；</p>",
        "<p><li style='float: left;'></li>与国家安全、国防安全直接相关的；</p>",
        "<p><li style='float: left;'></li>与公共安全、公共卫生、重大公共利益直接相关的；</p>",
        "<p><li style='float: left;'></li>与刑事侦查、起诉、审判和执行判决等直接相关的；</p>",
        "<p><li style='float: left;'></li>我们有充分证据表明您存在主观恶意或滥用权利的；</p>",
        "<p><li style='float: left;'></li>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>",
        "<p><li style='float: left;'></li>响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>",
        "<p><li style='float: left;'></li>涉及商业秘密的。</p>",
        "<p>除法律法规另有规定，当您更正、删除您的个人信息时，我们可能不会立即从备份系统中更正或删除相应的信息，但会在备份更新时更正或删除这些信息。</p>",

        "<p style='font-size:18px;font-weight:bold;'>未成年人保护</p>",
        "<p style='font-weight:bold;'>1.我们非常重视对未成年人个人信息的保护</p>",
        "<p>我们推定您是年满十八周岁且具有完全民事行为能力。如您为18周岁以下的末成年人，我们要求您请您的父母或其他监护人仔细阅读本政策，并在使用我们的产品或服务或向我们提供信息前，应事先取得您的父母或其他监护人的同意。我们将根据国家相关法律法规的规定保护未成年人的相关信息。</p>",
        "<p>我们承诺对未成年人个人信息严格保密，除以下情形外，我们不会与任何第三方分享未成年人的个人信息:</p>",
        "<p><li style='float: left;'></li>与监护人共享；</p>",
        "<p><li style='float: left;'></li>事先已得到监护人的明确授权同意；</p>",
        "<p><li style='float: left;'></li>为了必要/合理的业务的顺利开展、履行我们在相关用户协议或本指引中的义务和遵守法律规定等目的，与为我们的产品与或服务提供功能支持的服务提供商的必要共享，但我们承诺我们只会共享未成年人必要个人信息，如果我们需要改变未成年人个人信息的处理目的时，将再次征求您的授权同意。请您放心，我们会对服务商和其服务行为等进行安全评估，签署协议，明确责任、处理事项、处理期限、处理性质和目的等，要求其处理行为不得超出我们的授权范围；除得到您的授权同意，否则我们不会将您监护的未成年人的个人信息与第三方共享用于营销活动；</p>",
        "<p><li style='float: left;'></li>与(可能的)诉讼、仲裁或其他法律程序相关的规定；</p>",
        "<p><li style='float: left;'></li>政府机关或其他法定授权组织的要求。</p>",
        "<p style='font-weight:bold;'>2.补救措施</p>",
        "<p>如果您未能取得您监护人的同意或您未同意您的被监护人使用我们的产品或服务并向我们提供信息，请您或被监护人立即停止使用我们的产品或服务并及时与我们取得联系。</p>",
        "<p>在收到您的书面通知而知晓我们在未事先获得监护人同意的情况下收集了未成年人的个人信息时，我们会立即停止相关信息的收集及使用。</p>",

        "<p style='font-size:18px;font-weight:bold;'>本隐私条款的更改</p>",
        "<p><span style='font-weight:bold;'>为不断向您提供更好的服务，我们会适时修改本政策，并在本政策中、本公司网站中以及我们认为适当的位置发布这些更改。对于重大变更，我们会提供更显著的通知。</span>所述重大变更包括但不限于：</p>",
        "<p>1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>",
        "<p>2.我们在所有权结构方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>",
        "<p>3.个人信息共享、转让或公开披露的主要对象发生重大变化；</p>",
        "<p>4.您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>",
        "<p>5.我们的联络方式及投诉渠道发生变化时；</p>",
        "<p>6.个人信息安全影响评估报告表明存在高风险需要对安全保障等措施进行调整时；</p>",
        "<p>7.其他重要的或可能严重影响您的个人权益的情况发生。</p>",

        "<p style='font-size:18px;font-weight:bold;'>如何联系我们</p>",
        "<p>如您有关于网络信息安全的投诉和举报，或您对本隐私政策、您的信息的相关事宜有任何问题、意见或建议，请通过以下方式与我们联系:</p>",
        "<p>公司名称:长光卫星技术股份有限公司.</p>",
        "<p>地址:吉林省长春市北湖科技开发区明溪路1299号</p>",
        "<p>热线: 0431-86008580 (服务时段: 法定工作日08: 30-17: 30)</p>",
        "<p>邮箱: gongshengdiqiu@163.com</p>",
        "<p>我们将有专人跟进负责处理，一般情况下，我们将在收到您的问题、意见或建议，并验证您的用户身份后的七个工作日内予以处理。如您不满意我们的处理，您还可以通过法律途径向履行个人信息保护职责的部门进行投诉、举报。</p>",

      ],

      document_userAgreement:[
        "<p style='font-size:18px;font-weight:bold;'>首部及导言</p>",
        "<br />",
        "<p>欢迎用户使用吉林一号·共生地球！</p>",
        "<br />",
        "<p style='font-weight:bold;'>为了使用长光卫星技术股份有限公司（以下简称“长光卫星”）研发的吉林一号·共生地球服务（以下简称“本服务”），用户应当阅读并遵守《吉林一号·共生地球服务协议》 （以下简称“本协议”）以及与此相关的专项规则等。</p>",
        "<p style='font-weight:bold;'>请用户务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，以及开通或使用某项服务的单独协议或特别条款。限制、免责条款可能以加粗形式提示用户注意。</p>",
        "<p style='font-weight:bold;'>除非用户已阅读并接受本协议所有条款，否则用户无权使用吉林一号·共生地球服务。用户对本服务的登录、查看、发布信息等行为即视为用户已阅读并同意本协议的约束。用户有违反本协议的任何行为时，长光卫星有权依照违反情况，随时单方限制、中止或终止向用户提供本服务，并有权追究用户的相关责任。</p>",
        "<p>此外，用户清楚知悉并理解，因实际需要，特定的特殊功能服务条款可能会存在协议条款名称发生修改、变更的情况，对此用户明确认知并认可，该等情况并不构成对相关协议条款内容的变更，也不影响相关协议条款的效力。</p>",
        "<p>本协议适用于在中华人民共和国大陆地区内的个人或在中华人民共和国大陆地区注册的实体所运营的任何帐号。</p>",

        "<p style='font-size:18px;font-weight:bold;'>1、协议的范围</p>",
        "<p>吉林一号·共生地球是由长光卫星技术股份有限公司（以下简称长光卫星）开发。请您务必认真阅读并理解用户协议中各项条款，包括免除或者限制长光卫星责任及对用户的权利限制条款，用户协议即构成您（即“用户”）和长光卫星之间的具有法律约束力的协议。</p>",
        "<p>吉林一号·共生地球非常重视您的个人信息和隐私的保护，将按照<a target='_blank' href='" + document.location.origin + document.location.pathname + "?pageType=privacy'>《吉林一号·共生地球隐私政策》</a>中所公布的政策在具体服务中进行隐私及个人信息的收集、存储、使用、披露等活动。您在注册吉林一号·共生地球账号前，应仔细阅读<a target='_blank' href='" + document.location.origin + document.location.pathname + "?pageType=privacy'>《吉林一号·共生地球隐私政策》</a>。</p>",
        "<p>本协议约定长光卫星与用户之间关于“吉林一号·共生地球”服务（以下简称“服务”）的权利义务。“用户”是指注册、登录、使用本服务的个人或组织。本协议可由长光卫星随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在本网页中查阅最新版协议条款。在修改协议条款后，如果用户不接受修改后的条款，请立即停止使用吉林一号·共生地球提供的服务，用户继续使用吉林一号·共生地球提供的服务将被视为接受修改后的协议。</p>",
        "<p style='font-weight:bold;'>本协议内容同时包括长光卫星可能不断发布的关于本服务的相关协议、服务声明、业务规则及公告指引等内容（以下统称为“专项规则”）。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。</p>",
        "<p>本协议适用于网页端、移动客户端（包括IOS、安卓及已有或未来将新增的任何其他移动客户端）等各类平台或媒介中吉林一号·共生地球所提供的各项服务。您知悉并理解，为享受上述相关服务，您必须自行提供相关上网设备（如：个人电脑、手机、平板电脑或其他设备）并自行负担相关网络使用和商品服务支付所产生的有关费用。</p>",

        "<p style='font-size:18px;font-weight:bold;'>2、帐号说明</p>",
        "<p style='font-weight:bold;'>2.1 账号注册</p>",
        "<p>2.1.1用户在使用本服务前需要注册一个吉林一号·共生地球帐号。吉林一号·共生地球帐号通过电子邮箱帐号进行绑定注册，请用户使用未与吉林一号·共生地球帐号绑定的电子邮箱帐号注册吉林一号·共生地球帐号。吉林一号·共生地球帐号可与共生地球APP账号进行绑定，用户可通过共生地球APP对吉林一号·共生地球帐号进行注册绑定，一个共生地球APP账号可注册绑定一个吉林一号·共生地球账号。</p>",
        "<p>吉林一号·共生地球有权根据用户需求和产品需要对帐号注册和绑定的方式进行变更，而无需事先通知用户。</p>",
        "<p>2.1.2如果注册申请者有被吉林一号·共生地球封禁的先例或涉嫌虚假注册及滥用他人名义注册，及其他不能得到许可的理由，吉林一号·共生地球将拒绝其注册申请。</p>",
        "<p>2.1.3在用户注册及使用本服务时，吉林一号·共生地球需要搜集能识别用户身份的个人信息以便长光卫星可以在必要时联系用户，或为用户提供更好的使用体验。长光卫星搜集的信息包括但不限于用户的邮箱、手机号。</p>",
        "<p style='font-weight:bold;'>2.2 账号安全与个人信息保护</p>",
        "<p>2.2.1用户一旦注册成功，成为吉林一号·共生地球的用户，将得到一个用户名和密码，并有权利使用自己的用户名及密码随时登录吉林一号·共生地球。</p>",
        "<p style='font-weight:bold;'>2.2.2保护用户个人信息是长光卫星的一项基本原则，长光卫星将会采取合理的措施保护用户的个人信息。除法律法规规定的情形外，未经用户许可长光卫星不会向第三方公开、透露用户个人信息。长光卫星对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全，详情请见<a target='_blank' href='" + document.location.origin + document.location.pathname + "?pageType=privacy'>《吉林一号·共生地球隐私政策》</a>。</p>",
        "<p>2.2.3用户在申请本服务过程中，需要填写一些必要的信息，请保持这些信息的真实、准确、合法、有效并注意及时更新，以便长光卫星向用户提供及时有效的帮助，或更好地为用户提供服务。根据相关法律法规和政策，请用户填写真实的身份信息。若用户填写的信息不完整或不准确，则可能无法使用本服务或在使用过程中受到限制。</p>",
        "<p>2.2.4用户对用户名和密码的安全负全部责任，同时对以其用户名进行的所有活动和事件负全责。</p>",
        "<p>2.2.5吉林一号·共生地球帐号密码由用户自行设定。长光卫星特别提醒用户应妥善保管用户的帐号和密码。长光卫星与用户共同负有维护帐号安全的责任。长光卫星会采取并不断更新技术措施，努力保护用户的帐号在服务器端的安全。用户需要采取特定措施保护用户的帐号安全，包括但不限于妥善保管吉林一号·共生地球帐号与密码、安装防病毒木马软件、定期更改密码等措施。当用户使用完毕后，应安全退出。用户同意在任何情况下不向他人透露帐号或密码信息。<span style='font-weight:bold;'>因用户保管不善可能导致帐号被他人使用（包括但不限于遭受盗号、密码失窃）或信息数据泄漏，责任由用户自行承担。</span>用户理解并同意，在用户未进行投诉或提出帐号申诉等方式明确告知长光卫星帐号被他人使用或信息数据泄漏等情况并提供相关证明材料前，长光卫星有理由相信该帐号行为是用户使用帐号的行为。</p>",
        "<p style='font-weight:bold;'>2.2.6未经用户的同意，长光卫星不会向长光卫星以外的任何公司、组织和个人披露用户的个人信息，但法律法规另有规定的除外。</p>",
        "<p>2.2.7长光卫星非常重视对未成年人个人信息的保护。若用户是18周岁以下的未成年人，在使用长光卫星的服务前，应事先取得用户家长或法定监护人的书面同意。</p>",
        "<p>2.2.8用户应对通过本服务了解、接收或可接触到的包括但不限于其他用户在内的任何人的个人信息予以充分尊重，用户不应以搜集、复制、存储、传播或以其他任何方式使用其他用户的个人信息，否则，由此产生的后果由用户自行承担。</p>",
        "<p>2.2.9 在用户怀疑他人在使用用户的帐号或密码时，用户同意立即通知长光卫星公司。如果用户当前使用的吉林一号·共生地球帐号并不是用户初始申请注册的或者通过长光卫星提供的其他途径获得的，但用户却知悉该帐号当前的密码，用户不得用该帐号登录或进行任何操作，并请用户在第一时间通知长光卫星或者该帐号的初始申请注册主体。如果长光卫星发现用户并非该帐号初始申请注册主体，长光卫星有权在未经通知的情况下终止用户使用该帐号。</p>",
        "<p>2.2.10 用户理解并同意，为保护用户及其他用户的数据安全，防止用户信息泄露、毁损、篡改或者丢失，长光卫星有权对用户接入的信息系统实行接入审查，包括但不限于技术水平审查、安全水平审查、主体资质审查等，并根据审查结果向用户提出防入侵、防病毒等措施建议。若用户的信息系统仍无法符合保护用户数据安全的要求，长光卫星有权拒绝或终止提供本服务。</p>",
        "<p>2.2.11如果用户的吉林一号·共生地球帐号被盗、密码遗忘或因其他原因导致无法正常登录，用户可以按照长光卫星的申诉途径进行申诉。长光卫星并不承诺用户一定能通过申诉找回帐号。</p>",
        "<p style='font-weight:bold;'>2.3 账号使用与管理</p>",
        "<p>2.3.1用户用基于本服务的吉林一号·共生地球帐号由用户独立维护、运营并独立承担全部责任。长光卫星不会、也不可能参与该吉林一号·共生地球帐号的运营等独立活动；</p>",
        "<p style='font-weight:bold;'>2.3.2因用户的原因导致的任何纠纷、责任等，以及用户或用户的吉林一号·共生地球帐号违反相关法律法规或本协议约定引发的任何后果，均由用户独立承担责任、赔偿损失，与长光卫星无关。如侵害到长光卫星或他人权益的，用户须自行承担全部责任和赔偿一切损失。</p>",
        "<p>2.3.3吉林一号·共生地球帐号的所有权归长光卫星公司所有，用户完成申请注册手续后，获得吉林一号·共生地球帐号的使用权，该使用权仅属于初始申请注册主体。帐号使用权禁止赠与、借用、租用、转让或售卖。</p>",
        "<p>2.3.4如用户违反相关法律法规、本协议以及其他规定，长光卫星有权进行独立判断并随时限制、冻结或终止用户对吉林一号·共生地球帐号的使用，且根据实际情况决定是否恢复使用。由此给用户带来的损失（包括但不限于通信中断，用户资料及相关数据清空等），由用户自行承担。</p>",
        "<p>2.3.5为了充分利用帐号资源，如果用户存在长期未完成注册、注册吉林一号·共生地球帐号后未及时进行初次登录使用，或长期未登陆使用吉林一号·共生地球帐号等情形，长光卫星有权终止该帐号的使用。</p>",
        "<p>2.3.6在需要终止使用本产品或服务的账号时，符合以下条件的，您可以申请注销您的账号:</p>",
        "<p><li style='float: left;'></li>您仅能申请注销您本人的账号，并依照本产品或服务的流程进行注销；</p>",
        "<p><li style='float: left;'></li>您仍应对您在注销账号前且使用本产品或服务期间的行为承担相应责任，同时长光卫星仍可在法定期限内保存您注销前的相关注册账号信息；个人信息将按照《个人信息保护法》的规定在注销后的合理期限内进行匿名化处理；</p>",
        "<p><li style='float: left;'></li>注销账户上不存在未履行完毕的义务或其他不适宜注销的情形；</p>",
        "<p><li style='float: left;'></li>注销成功后，该注销账号的账号信息、记录、功能等无法恢复或提供给您。</p>",

        "<p style='font-size:18px;font-weight:bold;'>3、遥感实验室服务说明</p>",
        "<p style='font-weight:bold;'>3.1 基本服务</p>",
        "<p>本产品和或服务依托地理信息数据，以良好的地球浏览、搜索功能为核心要素，使用户探索需求与浏览内容得到深度匹配，提供在线影像数据浏览、创作等功能和服务，具体功能和服务由长光卫星根据实际情况或服务现状提供。长光卫星有权自行确定服务内容和形式，并有权自行决定增加、变更中断和停止本服务。</p>",
        "<p style='font-weight:bold;'>3.2 内容购买与下载</p>",
        "<p>3.2.1您可使用吉林一号·共生地球进行影像内容的购买，购买完成后您可对已购买内容及进行下载，如您是未成年人或限制民事行为能力人，请在监护人同意后进行购买。</p>",
        "<p style='font-weight:bold;'>3.2.2由于遥感信息内容的特殊性，您对吉林一号·共生地球中的内容须自行加以判断，并承担因使用内容而引起的风险。除法律法规明确规定外，您因该等内容进行下载或使用的损害或损失由您自行承担。</p>",
        "<p>3.2.3进行购买时请您务必仔细确认所购内容的品名、价格、数量、规格、限制性要求等重要事项，因您个人原因产生的错误购买等行为均由您自行承担。</p>",
        "<p>3.2.4您的下载行为应当基于真实的下载需求，不得存在对内容实施恶意下载等扰乱吉林一号·共生地球正常使用秩序的行为。基于维护吉林一号·共生地球使用秩序的需要，长光卫星发现上述情形时可主动执行关闭相关账号下载权限等操作。</p>",
        "<p>3.2.5如您的下载存在利用吉林一号·共生地球系统漏洞、规则漏洞，不正当获取平台利益等行为，基于维护吉林一号·共生地球使用秩序、下载安全及长光卫星合法权益的需要，长光卫星发现上述情形时可主动执行关闭相关账号下载权限等操作。</p>",
        "<p style='font-weight:bold;'>3.2.6您对吉林一号·共生地球影像内容购买前后的使用权限，详见专项规则<a target='_blank' href='" + document.location.origin + document.location.pathname + "?pageType=imageUserAgreement'>《吉林一号·共生地球影像授权服务协议》</a>。</p>",
        "<p style='font-weight:bold;'>3.3内容分享与转发</p>",
        "<p style='font-weight:bold;'>您可对吉林一号·共生地球的影像产品内容进行分享、转发，但未经长光卫星书面许可，您不得采用截屏、“蜘蛛”(spider)程序等技术手段方式复制、读取、采用、统计吉林一号·共生地球服务的相关数据，包括软件、程序、技术、网页、影像产品内容等相关信息，或者对上述数据进行任何形式的销售和商业使用。</p>",
        "<p style='font-weight:bold;'>3.4 创作内容发布</p>",
        "<p>3.4.1您可使用吉林一号·共生地球创作中心发表属于您原创或您有权发表的观点看法、文字、信息、图片、视频等内容。</p>",
        "<p>3.4.2您知悉、理解并同意，吉林一号·共生地球创作中心是一个内容创作分享平台，您通过本产品或服务创作、上传、发布、或传播内容(包括但不限于文字、图片、图像、视频或音频中的音乐、声音、对话等)，将默认在共生地球系列产品服务中进行分享与展示，包括但不限于共生地球APP客户端、吉林一号·共生地球等，若您将通过本服务创作的上述相关内容通过转发、复制、调用等方式发布或传输到其他平台，<span style='font-weight:bold;'>针对内容的版权等相关信息详见本协议知识产权章节</span>。</p>",
        "<p style='font-weight:bold;'>3.4.3您通过吉林一号·共生地球创作中心发布内容时必须遵守有关法律法规，不得利用吉林一号·共生地球创作中心制作、复制、发布、传播、储存任何违反法律法规、危害国家安全、可能对用户财产安全或信安全造成损失的信息、营销信息、低俗不当信息、不良信息以及不实信息等内容。关于吉林一号·共生地球创作中心创作的具体规则，请阅读并遵守<a target='_blank' href='" + document.location.origin + document.location.pathname + "?pageType=createAgreement'>《吉林一号·共生地球创作中心创作规范》</a>。</p>",
        "<p style='font-weight:bold;'>3.5收费服务</p>",
        "<p>3.5.1 吉林一号·共生地球部分服务是以收费方式提供的，如用户使用收费服务，请遵守相关的专项规则。</p>",
        "<p><span style='font-weight:bold;'>长光卫星可能根据实际需要对收费服务的收费标准、方式进行修改和变更，长光卫星也可能会对部分免费服务开始收费。</span>前述修改、变更或开始收费前，长光卫星将在相应服务页面进行通知或公告。如果用户不同意上述修改、变更或付费内容，则应停止使用该服务。</p>",
        "<p>3.5.3 如用户使用收费服务时，需要使用其他公司提供的支付服务的，应当遵守该等服务的相关协议和规则。</p>",
        "<p>3.5.4长光卫星为向您提供的吉林一号·共生地球服务付出了大量的成本，除吉林一号·共生地球明示的收费业务外，长光卫星向您提供的吉林一号·共生地球服务是免费的。如未来长光卫星向您收取合理费用，长光卫星会采取合理方式并以合理的期限提前通知您，确保您有充分选择的权利。</p>",
        "<p style='font-weight:bold;'>3.6服务使用许可</p>",
        "<p>3.6.1您使用本产品或服务应通过访问官方网站，若您并非从长光卫星或经长光卫星授权的第三方访问获取本服务，长光卫星无法保证该产品或服务的正常使用，您因此遭受的任何损失与长光卫星无关。</p>",
        "<p>3.6.2为更好的提升用户体验及服务，长光卫星有权不定期提供本产品或服务的更新或改变(包括但不限于服务修改、升级、功能强化、开发新服务等)，但长光卫星不对升级或更新本产品或服务做任何承诺。除非本协议另有明确规定，本产品或服务和网站的任何升级或更新版本，均受到本协议的规范。</p>",
        "<p>3.6.3为保证本产品或服务安全、提升用户体验及服务，在本产品或服务的部分或全部更新后，长光卫星将在可行的情况下以妥当的方式(包括但不限于系统提示、公告、站内信等)提示您，您需接受更新后的版本，长光卫星不会对历史版本的功能做任何提供。</p>",
        "<p style='font-weight:bold;'>3.6.4除非得到长光卫星事先书面授权，您不得以任何形式对本产品或服务进行包括但不限于改编、复制、传播、或交易等未经授权的访问或使用。</p>",
        "<p>3.6.5使用本产品或服务需自行准备与软件及相关服务有关的终端设备(如电脑、手机等)，一旦您在终端设备中打开本产品或服务，即视为您使用本产品或服务。为充分实现本产品或服务的全部功能，您可能需要将终端设备联网，由您自行承担相关设备及所需要的费用(如流量费、上网费等)</p>",
        "<p>3.6.6您理解并同意长光卫星依据本协议授予您项个人的、不可转让的、不可转授权的、可撤销的、非独占的合法使用本产品或服务的普通使用许可。您不得(且您不得允许其他人)为任何商业目的使用本产品/网站，从而直接或间接获得任何形式的收益。长光卫星未明示授权您的其他权利仍由长光卫星保留，您若行使这些未明示授权的其他权利前须另行获得长光卫星的书面许可，即使长光卫星未行使前述任何权利，也并不视为对该权利的放弃。</p>",

        "<p style='font-size:18px;font-weight:bold;'>4、用户行为规范</p>",
        "<p style='font-weight:bold;'>4.1 信息内容规范</p>",
        "<p>4.1.1 本协议所述信息内容是指用户使用本服务过程中所制作、复制、发布、传播的任何内容，包括但不限于吉林一号·共生地球帐号头像、名称等注册信息及用户中心各类资料信息，或文字、图片、视频、图文、相关链接等内容，以及其他使用吉林一号·共生地球帐号或吉林一号·共生地球服务所产生的内容，也称“吉林一号·共生地球信息内容”。</p>",
        "<p>4.1.2用户理解并同意，用户有义务在注册时提供自己的真实资料，并保证诸如手机号码、所在地区等内容的有效性及安全性，保证吉林一号·共生地球工作人员可以通过上述联系方式与用户取得联系。同时，用户也有义务在相关资料实际变更时及时更新有关注册资料。</p>",
        "<p style='font-weight:bold;'>4.1.3 用户理解并同意，吉林一号·共生地球致力于为用户提供文明健康、规范有序的网络环境，用户不得利用吉林一号·共生地球帐号或吉林一号·共生地球服务制作、复制、发布、传播如下干扰吉林一号·共生地球正常运营，以及侵犯其他用户或第三方合法权益的内容：</p>",
        "<p>4.1.3.1 发布、传送、传播、储存违反国家法律法规禁止的内容：</p>",
        "<p><li style='float: left;'></li>违反宪法确定的基本原则的；</p>",
        "<p><li style='float: left;'></li>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>",
        "<p><li style='float: left;'></li>损害国家荣誉和利益的；</p>",
        "<p><li style='float: left;'></li>煽动民族仇恨、民族歧视，破坏民族团结的；</p>",
        "<p><li style='float: left;'></li>破坏国家宗教政策，宣扬邪教和封建迷信的；</p>",
        "<p><li style='float: left;'></li>散布谣言，扰乱社会秩序，破坏社会稳定的；</p>",
        "<p><li style='float: left;'></li>散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>",
        "<p><li style='float: left;'></li>侮辱或者诽谤他人，侵害他人合法权益的；</p>",
        "<p><li style='float: left;'></li>煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</p>",
        "<p><li style='float: left;'></li>以非法民间组织名义活动的；</p>",
        "<p><li style='float: left;'></li>不遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的；</p>",
        "<p><li style='float: left;'></li>歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；</p>",
        "<p><li style='float: left;'></li>宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；</p>",
        "<p><li style='float: left;'></li>含有法律、行政法规禁止的其他内容的。</p>",
        "<p>4.1.3.2 发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</p>",
        "<p>4.1.3.3 涉及他人隐私、个人信息或资料的内容；</p>",
        "<p>4.1.3.4 发表、传送、传播骚扰信息、广告信息及垃圾信息或含有任何性或性暗示的内容；</p>",
        "<p>4.1.3.5 发布、传送、传播谣言、虚假信息或其他含有不实信息的内容；</p>",
        "<p>4.1.3.6 其他违反法律法规、政策及公序良俗、社会公德或干扰吉林一号·共生地球正常运营和侵犯其他用户或第三方合法权益内容的信息；</p>",
        "<p>4.1.3.7 发布、传送、传播侵害未成年人合法权益或者损害未成年人身心健康的内容；</p>",
        "<p>4.1.3.8 发布、传送、传播对吉林一号·共生地球生态造成不良影响的内容：</p>",
        "<p><li style='float: left;'></li>使用夸张标题，内容与标题严重不符的；</p>",
        "<p><li style='float: left;'></li>炒作绯闻、丑闻、劣迹等的；</p>",
        "<p><li style='float: left;'></li>不当评述自然灾害、重大事故等灾难的；</p>",
        "<p><li style='float: left;'></li>带有性暗示、性挑逗等易使人产生性联想的；</p>",
        "<p><li style='float: left;'></li>展现血腥、惊悚、残忍等致人身心不适的；</p>",
        "<p><li style='float: left;'></li>煽动人群歧视、地域歧视等的；</p>",
        "<p><li style='float: left;'></li>宣扬低俗、庸俗、媚俗内容的；</p>",
        "<p><li style='float: left;'></li>可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；</p>",
        "<p><li style='float: left;'></li>其他对吉林一号·共生地球生态造成不良影响的内容。</p>",
        "<p style='font-weight:bold;'>4.2 平台使用规范</p>",
        "<p style='font-weight:bold;'>4.2.1 本条所述平台使用是指用户使用本服务所进行的任何行为，包括但不限于吉林一号·共生地球注册登录、吉林一号·共生地球创作中心创作、吉林一号·共生地球帐号运营推广以及其他使用吉林一号·共生地球帐号或吉林一号·共生地球服务所进行的行为。其中，关于吉林一号·共生地球创作中心创作的具体规则，请阅读并遵守<a target='_blank' href='" + document.location.origin + document.location.pathname + "?pageType=createAgreement'>《吉林一号·共生地球创作中心创作规范》</a>。</p>",
        "<p>4.2.2 用户不得利用吉林一号·共生地球帐号或吉林一号·共生地球服务进行如下行为：</p>",
        "<p><li style='float: left;'></li>提交、发布虚假信息；</p>",
        "<p><li style='float: left;'></li>强制、诱导其他用户点击链接页面或分享信息的；</p>",
        "<p><li style='float: left;'></li>虚构事实、隐瞒真相以误导、欺骗他人的；</p>",
        "<p><li style='float: left;'></li>侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；</p>",
        "<p><li style='float: left;'></li>填写和提交帐号注册违反本协议规定；</p>",
        "<p><li style='float: left;'></li>未能按照吉林一号·共生地球业务流程注册和使用本服务，违反本服务功能限制或运营策略，或采取任何措施规避前述流程、限制或策略，干扰吉林一号·共生地球正常运营的；</p>",
        "<p><li style='float: left;'></li>未经长光卫星书面许可利用其他吉林一号·共生地球帐号、共生地球APP帐号和任何功能，与第三方运营平台进行推广或互相推广的；</p>",
        "<p><li style='float: left;'></li>未经长光卫星书面许可使用插件、外挂或通过其他第三方工具、运营平台或任何服务接入本服务和相关系统的；</p>",
        "<p><li style='float: left;'></li>利用吉林一号·共生地球帐号或吉林一号·共生地球服务从事包括但不限于欺诈、传销、违法物品营销等任何违法犯罪活动的；</p>",
        "<p><li style='float: left;'></li>制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；</p>",
        "<p><li style='float: left;'></li>未经长光卫星书面许可，自行或授权、允许、协助任何第三人对吉林一号·共生地球服务的相关数据进行非法获取，“非法获取”是指采用包括但不限于“蜘蛛”(spider)程序、爬虫程序、拟人程序等非真实用户或避开、破坏技术措施等非正常浏览的手段、方式，读取、复制、转存、获得本服务数据和各类信息的行为；</p>",
        "<p><li style='float: left;'></li>未经长光卫星书面许可，与第三方达成任何形式的协议、承诺或确认，在吉林一号·共生地球发布任何对本服务所提供的任何功能进行排他、排斥、排除、妨碍、阻碍、强制选择等非善意竞争的内容；</p>",
        "<p><li style='float: left;'></li>任何导致或可能导致长光卫星与第三方产生纠纷、争议或诉讼的行为。</p>",
        "<p>4.2.3 用户在使用本服务的过程中，不得从事包括但不限于以下行为，也不得为以下行为提供便利（包括但不限于为用户的行为提供便利等）：</p>",
        "<p><li style='float: left;'></li>删除、隐匿、改变本服务显示或其中包含的任何专利、著作权、商标或其他权利声明；</p>",
        "<p><li style='float: left;'></li>以任何方式干扰或企图干扰长光卫星任何产品、任何部分或功能的正常运行，或者制作、发布、传播上述工具、方法等；</p>",
        "<p><li style='float: left;'></li>除无法绕开的内容显示需要外，未经长光卫星书面许可，不得以长光卫星名义使用任何长光卫星商标标识或其任何变体、缩写、改写等；</p>",
        "<p><li style='float: left;'></li>避开、尝试避开或声称能够避开任何内容保护机制，或导致用户认为其直接与长光卫星及长光卫星相关产品进行交互；</p>",
        "<p><li style='float: left;'></li>除无法绕开的信息内容显示需要外，在未获得长光卫星书面许可的情况下，以任何方式使用长光卫星URL地址、技术接口等；</p>",
        "<p><li style='float: left;'></li>在未经过用户同意的情况下，向任何其他用户及他方显示或以其他任何方式提供该用户的任何信息；</p>",
        "<p><li style='float: left;'></li>在没有获得用户和长光卫星明示同意的情况下，擅自以长光卫星的名义向用户发布、发送商业广告等信息；</p>",
        "<p><li style='float: left;'></li>为任何用户自动登录到本服务平台提供代理身份验证凭据；</p>",
        "<p><li style='float: left;'></li>提供跟踪功能，包括但不限于识别其他用户在个人主页上查看、点击等操作行为；</p>",
        "<p><li style='float: left;'></li>自动将浏览器窗口定向到其他网页；</p>",
        "<p><li style='float: left;'></li>未经授权获取对长光卫星产品或服务的访问权；</p>",
        "<p><li style='float: left;'></li>发布的信息内容中含有计算机病毒、木马或者其他恶意程序、链接等任何可能危害长光卫星或用户权益和终端信息安全等的内容；</p>",
        "<p><li style='float: left;'></li>捏造或虚构事实，或未经长光卫星书面同意，公开表达或暗示，用户与长光卫星之间存在合作关系，包括但不限于相互持股、商业往来或合作关系等，或声称长光卫星对用户的认可；</p>",
        "<p><li style='float: left;'></li>其他长光卫星认为不应该、不适当的行为、内容。</p>",
        "<p style='font-weight:bold;'>4.2.4 用户须知，由于遥感影像信息的特殊性，用户对基本吉林一号·共生地球获得的遥感影像信息的使用，需符合《遥感影像公开使用管理规定（试行）》等法律法规的规范要求。</p>",
        "<p style='font-weight:bold;'>4.3 充值行为规范</p>",
        "<p style='font-weight:bold;'>4.3.1 长光卫星向用户提供虚拟增值服务本身属于商业行为，用户有权自主决定是否根据长光卫星各具体产品自行确定的收费项目（包括但不限于购买吉林一号·共生地球内的影像内容的使用权、接受其他增值服务等各类收费项目）及收费标准支付相应的费用，以获得相应的虚拟增值服务。如您不按相应标准支付相应费用的，您将无法获得相应的服务。</p>",
        "<p style='font-weight:bold;'>4.3.2 您知悉并同意：收费项目或收费标准的改变、调整是一种正常的商业行为，您不得因为收费项目或收费标准的改变、调整而要求长光卫星进行赔偿或补偿。您知悉并同意，您使用法定货币进行账号充值/平台内容购买或其他增值服务的，您所购买或兑换的内容/其他增值服务将不能退还或兑换成法定货币，但法律另有强制性规定的除外。</p>",
        "<p style='font-weight:bold;'>4.3.3 未经长光卫星许可，您不得擅自与其他用户进行平台内虚拟道具/其他增值服务的交易，或从第三方通过购买、接受赠与或者其他式获得前述增值服务。长光卫星不对第三方交易行为（第三方交易，是指您从第三方通过购买、接受赠与或者其他的方式获得前述增值服务的行为）负责，并且不受理因任何第三方交易发生纠纷而带来的申诉。</p>",
        "<p style='font-weight:bold;'>4.4 责任承担</p>",
        "<p>吉林一号·共生地球仅为用户提供地图类资源获取、分享、创作及传播的平台，用户必须为自己注册的帐号下的一切行为负责，包括用户所发表的任何内容以及由此产生的任何后果。用户应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。长光卫星无法且不会对因前述风险而导致的任何损失或损害承担责任。</p>",
        "<p style='font-weight:bold;'>4.5 用户须知</p>",
        "<p style='font-weight:bold;'>不对平台、技术接口、本服务数据进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）；不对平台、技术接口、本服务数据进行内容、功能、逻辑及界面等任何方面的修改；不得将平台、技术接口、本服务数据或业务用户本协议以外目的。</p>",

        "<p style='font-size:18px;font-weight:bold;'>5、数据的储存和使用规则</p>",
        "<p>5.1 长光卫星不对用户在本服务中相关数据的删除或储存失败负责。</p>",
        "<p>5.2 长光卫星有权根据实际情况自行决定单个用户在本服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。用户可根据自己的需要自行备份本服务中的相关数据。</p>",
        "<p>5.3 如果用户停止使用本服务或服务被终止或取消，长光卫星可以从服务器上永久地删除用户的数据。在服务停止、终止或取消后，长光卫星没有义务向用户返还任何数据。</p>",
        "<p style='font-weight:bold;'>5.4 本服务涉及的数据中归属于长光卫星的数据，除法律法规另有规定外，长光卫星享有全部权利，且是长光卫星的商业秘密。未经长光卫星事先书面同意，用户不得为本协议约定之外的目的使用前述数据，亦不得以任何形式将前述数据提供给他人，不得有任何破坏长光卫星与其客户之间业务关系的行为。</p>",
        "<p>5.5 用户在必要情况下若需要收集、保存或使用长光卫星各类服务用户任何数据，必须事先获得相应用户的明确同意，且仅应当收集为运营及功能实现目的而必须的用户数据，同时应告知被收集用户相关数据收集的目的、范围及使用方式等，保障长光卫星各类服务用户的知情权和选择权。</p>",
        "<p>5.6 一旦用户停止使用本服务，或长光卫星基于任何原因终止用户使用本服务，用户必须立即删除全部从长光卫星获得的数据（包括各种备份），且不得再以任何方式进行使用。</p>",
        "<p>5.7 除本服务为保障数据安全而采取的各类安全技术措施之外，用户应自行对因使用本服务而存储在长光卫星服务器的各类数据等信息，采取合理、安全的技术措施，确保其安全性，并对自己的行为所引起的结果承担全部责任。</p>",

        "<p style='font-size:18px;font-weight:bold;'>6、风险及免责</p>",
        "<p style='font-weight:bold;'>6.1 流量资费</p>",
        "<p>为了向用户提供有效的服务，本服务会利用用户终端设备的处理器和带宽等资源。本服务使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。</p>",
        "<p style='font-weight:bold;'>6.2 意外风险</p>",
        "<p style='font-weight:bold;'>在使用本服务时，须自行承担如下长光卫星不可掌控的风险内容，包括但不限于：</p>",
        "<p style='font-weight:bold;'><li style='float: left;'></li>由于受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏等不可抗拒因素可能引起的信息丢失、泄漏等损失和风险；</p>",
        "<p style='font-weight:bold;'><li style='float: left;'></li>用户或长光卫星的电脑软件、系统、硬件和通信线路出现故障导致的服务终端、数据丢失以及其他的损失和风险；</p>",
        "<p style='font-weight:bold;'><li style='float: left;'></li>用户操作不当或通过非长光卫星授权的方式使用本服务带来的损失和风险；</p>",
        "<p style='font-weight:bold;'><li style='float: left;'></li>用户发布的内容被他人转发、分享，因此等传播可能带来的风险和责任；</p>",
        "<p style='font-weight:bold;'><li style='float: left;'></li>由于网络信号不稳定等原因，所引起的吉林一号·共生地球登录失败、资料同步不完整、页面打开速度慢等风险；</p>",
        "<p style='font-weight:bold;'><li style='float: left;'></li>不可抗力等风险因素：不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、风暴等以及社会事件如战争、动乱、政府行为等。</p>",
        "<p style='font-weight:bold;'><li style='float: left;'></li>其他长光卫星无法控制或合理预见的情形。</p>",
        "<p style='font-weight:bold;'>6.3 风险处理</p>",
        "<p>用户通过吉林一号·共生地球群发的内容可能会被其他用户或第三方复制、转载、修改或做其他用途，脱离用户的预期和控制，用户应充分意识到此类风险的存在，任何用户不愿被他人获知的信息都不应在吉林一号·共生地球发布。如果相关行为侵犯了用户的合法权益，用户可以通过吉林一号·共生地球进行投诉，长光卫星将依法进行处理。</p>",
        "<p style='font-weight:bold;'>6.4平台警示</p>",
        "<p>长光卫星依据本协议约定获得处理违法违规内容或行为的权利，该权利不构成长光卫星的义务或承诺，长光卫星不能保证及时发现违法违规情形或进行相应处理。</p>",
        "<p style='font-weight:bold;'>因业务发展需要，长光卫星保留单方面对本服务的全部或部分服务内容在任何时候不经任何通知的情况下变更、暂停、限制、终止或撤销的权利，用户需承担此风险。</p>",
        "<p style='font-weight:bold;'>6.5用户须知</p>",
        "<p>长光卫星会根据用户选择的服务类型向用户提供相应的服务。基于用户体验、平台运营安全、平台规则要求及健康发展等综合因素，长光卫星有权选择提供服务或开展合作的对象，有权决定功能开放、数据接口和相关数据披露的对象和范围，并有权视具体情况中止或终止向存有包括但不限于以下情形的用户提供本服务：</p>",
        "<p><li style='float: left;'></li>违反法律法规或本协议规定的；</p>",
        "<p><li style='float: left;'></li>影响使用者体验的；</p>",
        "<p><li style='float: left;'></li>存在安全隐患的；</p>",
        "<p><li style='float: left;'></li>与长光卫星或吉林一号·共生地球已有主要功能或功能组件相似、相同，或可实现上述功能或功能组件的主要效用的；</p>",
        "<p><li style='float: left;'></li>界面、风格、功能、描述或使用者体验与长光卫星或吉林一号·共生地球类似，可能造成长光卫星用户认为其所使用的功能或服务来源于长光卫星或经长光卫星授权的；</p>",
        "<p><li style='float: left;'></li>未遵循公平、对等原则与长光卫星开展合作的，包括但不限于用户在自有产品或平台、其他第三方产品或平台、吉林一号·共生地球及其他长光卫星产品或平台对用户自主选择或正常使用长光卫星产品进行禁止、阻碍、妨碍、误导或影响等；</p>",
        "<p><li style='float: left;'></li>违背长光卫星或其服务平台运营原则，或不符合长光卫星其他管理要求的。</p>",

        "<p style='font-size:18px;font-weight:bold;'>7、知识产权声明</p>",
        "<p>7.1长光卫星知识产权</p>",
        "<p>7.1.1.长光卫星或相应权利人拥有本产品和/或服务及相关内容的著作权、商标权、专利权等所有法定权利、资格和权益(不论这些权利是否已注册、不论这些权利可能存在于世界何处) ,包括但不限于软件、技术、程序、网页、文字、图片、图像、音频、视频、图表、版面设计、电子文档、域名、商标、有关数据等。这些权利受著作权法、商标法、专利法、反不正当竞争法等相关法律法规和国际条约的保护。此外，经由本产品或服务向您呈现的第三方服务或其他信息所包含的内容，亦受到著作权、商标权、专利权或其他专属权利的法律保护。</p>",
        "<p style='font-weight:bold;'>7.1.2.您对本条款的同意和对本产品或服务的使用，不涉及上述任何知识产权的转让，上述全部知识产权仍归长光卫星或相应权利人所有。未经长光卫星或相应权利人的事先书面许可，任何人不得擅自利用、转让或许可任何第三方实施、利用、转让上述知识产权，您亦不能修改、租借、出售、制作衍生作品或以其他方式使用任何部分或全部上述知识产权。</p>",
        "<p style='font-weight:bold;'>7.1.3.您不得以任何方式删除、掩藏、修改或替换本产品或服务中所附的或包含的任何专有权利声明，或长光卫星及/或合作伙伴的任何版权标识、商标、服务标记、标识、商号、企业名称、域名、审图号、出版号及其他明显的标志。</p>",
        "<p>7.1.4.除非您与长光卫星或相应权利人另行达成书面协议，您不能使用长光卫星或相应权利人的任何标志。本协议并未授予您以任何形式或目的使用本产品或服务标志的权利，也没有授予您使用任何长光卫星其他标志或任何第三方标志的权利。</p>",
        "<p>7.1.5 吉林一号·共生地球是一个获取、分享及传播信息的平台，为向所有用户提供更优质的服务，长光卫星可能会对吉林一号·共生地球帐号的昵称、头像、公开创作内容等公开非保密内容在法律允许的范围内进行使用，包括但不限于提供搜索、链接等服务。</p>",
        "<p>7.1.6 吉林一号·共生地球创作中心为用户提供了长光卫星部分遥感影像产品内容的使用与创作权利，该使用或创作不涉及上述任何知识产权的转让，用户理解并同意，用户向任何第三人分享、转发、复制包含上述影像产品或吉林一号·共生地球各类信息的行为，均应遵守吉林一号·共生地球为此制定的规范和标准，包括但不限于展示方式应为该信息或内容的原链接、确保附属于该信息或内容的功能可正常使用、署名影像产品来源等。</p>",
        "<p>7.1.7 任何未经长光卫星书面同意及权利人许可的非法获取行为，均属违法侵权行为。<span style='font-weight:bold;'>用户确认并同意，为及时、有效地保障用户基于本服务的合法权益，用户授权长光卫星在发现用户的合法权益（包括但不限于信息网络传播权、著作权等）可能受到侵害时，有权代为向涉嫌侵权的第三人采取法律手段进行维权，授权采取的法律手段包括但不限于发函警告、提起诉讼、申请仲裁、移送侦查机关处理等。</span></p>",
        "<p>7.2您的知识产权</p>",
        "<p>7.2.1您理解并同意，使用本产品或服务发布、上传的文字、 图片、视频、音频等必须由您原创或已获合法授权。您通过本产品和/或服务上传、发布的任何内容的知识产权归您或原始著作权人所有。</p>",
        "<p style='font-weight:bold;'>7.2.2您知悉、理解并同意，为持续改善并为您提供更好的服务，您通过本产品或服务上传、发布、传输或传播内容(包括但不限于文字、图片、图像、音频、视频和/或音频中的音乐、声音、对话等)，即表明您有权且同意授权长光卫星及或关联公司、控制公司、承继公司一项全球范围内、永久性的、不可撤销的、免费、非独家、可再许可(通过多层次)的权利(包括但不限于复制权、信息网络传播权、改编权、汇编权、修改权、翻译权、制作衍生品、表演和展示等权利)，使用范围包括但不限于当前或其他网站、应用程序、产品或终端设备等。您在此确认并同意，上述权利的授予包括在内容、长光卫星或长光卫星品牌有关的任何的宣传、推广、广告或相关营销中使用和以其他方式开发内容(全部或部分)的权利和许可。</p>",
        "<p>7.2.3若您认为长光卫星或第方利用本产品或服务侵犯了您的合法权益，您可以以书面方式向长光卫星提交权利通知及相关的支持性资料，长光卫星将会依据法律法规的要求和《权利保护声明》(作为本协议的附属协议) 进行处理。您理解并同意，如果您提供的权利通知的陈述失实，您将承担由此造成的全部损失(包括但不限于赔偿长光卫星及/或关联方、控制公司、承继公司因此而支付的罚款、赔偿金、诉讼费、律师费、公证费、鉴定费、保全费、调查证据费用等各种费用)。如果您对该等侵权行为并无确信，建议先行咨询专业人士。</p>",
        "<p style='font-size:18px;font-weight:bold;'>8、法律责任</p>",
        "<p style='font-weight:bold;'>8.1 违约处理</p>",
        "<p><span style='font-weight:bold;'>如果长光卫星发现、收到他人投诉或经监管机关依法通知用户存在违反本协议约定或违反法律法规规定的，长光卫星有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、删除部分或全部关注用户、限制或禁止使用部分或全部功能、帐号封禁直至注销的处罚，并公告处理结果。</span>长光卫星也有权依照本协议及专项规则的规定，拒绝再向该主体提供服务。如果用户发现任何人违反本协议规定或以其他不当的方式使用吉林一号·共生地球服务，请立即向吉林一号·共生地球投诉，我们将依法进行处理。</p>",
        "<p style='font-weight:bold;'>8.2 责任承担</p>",
        "<p>长光卫星有权依合理判断对违反有关法律法规或本协议规定的行为进行处理，对违法违规的任何人士采取适当的法律行动，并依据法律法规或监管机关依法要求，保存有关信息，向有关部门报告或配合调查等，用户应独自承担由此而产生的一切法律责任。</p>",
        "<p style='font-weight:bold;'>因用户违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，用户应当独立承担责任；长光卫星因此遭受损失的，用户也应当一并赔偿。</p>",
        "<p style='font-weight:bold;'>8.3 用户须知</p>",
        "<p style='font-weight:bold;'>为及时保障用户合法权益不受侵害，若用户的吉林一号·共生地球帐号存在权益纠纷，长光卫星有权根据情况，采取包括但不限于暂停、冻结该吉林一号·共生地球帐号的部分或全部功能等保护措施，直至有权机关作出生效裁判或用户在不违反本协议的前提下协商一致，并由此所产生的一切法律责任均与长光卫星无关。</p>",

        "<p style='font-size:18px;font-weight:bold;'>9、通知</p>",
        "<p style='font-weight:bold;'>9.1协议修改</p>",
        "<p>用户使用本服务即视为用户已阅读并同意受本协议的约束。长光卫星有权在必要时修改本协议条款。长光卫星可能会以包括但不限于在相关服务页面展示、网页公告、网页提示、电子邮箱、手机短信、常规的信件传送、用户注册使用本服务的帐号管理系统内发送站内信等方式中的一种或多种，向用户送达关于本服务的各种规则、通知、提示等信息，用户可以在相关服务页面查阅最新版本的条款。本协议条款变更后，如果用户继续使用吉林一号·共生地球服务，即视为用户已接受修改后的协议。如果用户不接受修改后的协议，应当停止使用吉林一号·共生地球服务。</p>",
        "<p style='font-weight:bold;'>9.2责任承担</p>",
        "<p>任何由于电子邮箱、手机号码、通讯地址等信息错误或其他不可归咎于长光卫星的原因，导致用户未收到相关规则、通知、提示等信息的，均不影响该等信息对用户所产生的法律效力，并用户应受其约束，由此产生的一切后果及责任由用户自行承担。</p>",
        "<p style='font-weight:bold;'>9.3服务推广</p>",
        "<p>长光卫星可以向用户的电子邮件、手机号码等发送可能与本服务不相关的其他各类信息，包括但不限于商业广告等。</p>",
        "<p style='font-weight:bold;'>9.4用户反馈</p>",
        "<p>若用户有任何事项需要反馈或通知长光卫星的，均应当按照本服务对外正式公布的联系方式或渠道系统进行提交，否则，长光卫星将无法收到用户的通知。</p>",

        "<p style='font-size:18px;font-weight:bold;'>10、其它</p>",
        "<p style='font-weight:bold;'>10.1 用户使用本服务即视为用户已阅读并同意受本协议的约束。长光卫星有权在必要时修改本协议条款。用户可以在相关服务页面查阅最新版本的条款。本协议条款变更后，如果用户继续使用吉林一号·共生地球服务，即视为用户已接受修改后的协议。如果用户不接受修改后的协议，应当停止使用吉林一号·共生地球服务。</p>",
        "<p style='font-weight:bold;'>10.2 本协议签订地为中华人民共和国吉林省长春市宽城区。</p>",
        "<p style='font-weight:bold;'>10.3 若用户和长光卫星之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，用户同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</p>",
        "<p>10.4 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>",
        "<p>10.5 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>",
        "<p>10.6 如果用户对本服务有意见或建议，可通过客服0431-86008580联系我们，我们将尽快审核所涉问题，并在法律法规规定的期限内回复您的请求。</p>",
        "<p style='font-weight:bold;'>10.7长光卫星郑重提醒用户注意本协议中免除长光卫星责任和限制用户权利的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。</p>",
        "<p style='font-weight:bold;'>10.8 本协议最终解释权归长光卫星所有，并且保留一切解释和修改的权力。</p>",
        "<br />",
        "<p>长光卫星技术股份有限公司</p>",




      ],

      document_createAgreement:[
        "<p style='font-size:18px;font-weight:bold;'>一 原则</p>",
        "<p>吉林一号·共生地球创作中心致力于为用户提供绿色、健康的吉林一号·共生地球生态环境，努力打造一个个人、机构与企业用户之间交流和服务的优质平台，给予用户更多的选择和便利，进一步降低沟通和交易成本并创造更多的社会价值。</p>",
        "<p>基于上述目标目标，我们确定以下原则作为平台使用者基础规范。</p>",
        "<p><li style='float: left;'></li>遵守国家相关法律法规，不从事违法或违反《吉林一号·共生地球服务协议》及相关规则的内容和行为；</p>",
        "<p><li style='float: left;'></li>不发送或创作垃圾信息，不进行过度营销行为，鼓励向用户传送符合需求的真实资讯。</p>",
        "<p><li style='float: left;'></li>提供具有价值的并与帐号高度相关的内容。</p>",

        "<p style='font-size:18px;font-weight:bold;'>二 相关条款</p>",
        "<p>使用吉林一号·共生地球创作中心的服务，使用者必须阅读并遵守《吉林一号·共生地球服务协议》以及长光卫星为此制定的专项规则等。本创作规范是在上述协议及规则基础上进行解释和说明，相关内容旨在帮助使用者更加清晰地理解和遵守相关协议和规则，以便能够更加顺利地在吉林一号·共生地球创作中心进行创作，而不是修改或变更上述协议及规则中的任何条款。</p>",

        "<p style='font-size:18px;font-weight:bold;'>三 账号行为规范</p>",
        "<p>创作中心的创作内容将在共生地球系列产品中进行展示，创作中心的良好可持续发展有赖于广大创作者用户的共同努力与支持，以下内容更加清晰地描述了创作中心的各类账号行为规范。</p>",
        "<p style='font-weight:bold;'>1 注册及账户信息规范</p>",
        "<p>1.1 注册绑定的邮箱地址要求真实存在，通过该邮箱激活帐号。</p>",
        "<p>1.2 使用共生地球APP绑定注册时，一个APP账号只能绑定一个吉林一号·共生地球账号。</p>",
        "<p>1.3 修改帐号名称时，应当与账号介绍的内容相符。</p>",
        "<p>1.4 帐号名称、头像、功能介绍等资料不得涉及色情、暴力等违法违规内容。</p>",
        "<p>1.5 帐号名称、头像、功能介绍等资料不得涉及侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利。</p>",
        "<p>1.6 帐号头像不得涉及仿冒官方消息提醒以诱导用户点击，如头像设置小红点或数字等。</p>",
        "<p style='font-weight:bold;'>2 发布内容规范</p>",
        "<p>创作中心的提交发布的内容需要遵守《吉林一号·共生地球服务协议》、《吉林一号·共生地球创作中心创作规范》以及相关法律法规的规定。用户发布内容如涉及违反相关规定，一经发现将根据违规程度对帐号采取相应的处理措施，违规内容包括但不限于：</p>",
        "<p>2.1 违反国家法律法规禁止的内容</p>",
        "<p><li style='float: left;'></li>违反宪法确定的基本原则的；</p>",
        "<p><li style='float: left;'></li>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>",
        "<p><li style='float: left;'></li>损害国家荣誉和利益的；</p>",
        "<p><li style='float: left;'></li>煽动民族仇恨、民族歧视，破坏民族团结的；</p>",
        "<p><li style='float: left;'></li>破坏国家宗教政策，宣扬邪教和封建迷信的；</p>",
        "<p><li style='float: left;'></li>散布不实信息，扰乱社会秩序，破坏社会稳定的；</p>",
        "<p><li style='float: left;'></li>散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>",
        "<p><li style='float: left;'></li>侮辱或者诽谤他人，侵害他人合法权益的；</p>",
        "<p><li style='float: left;'></li>煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</p>",
        "<p><li style='float: left;'></li>以非法民间组织名义活动的；</p>",
        "<p><li style='float: left;'></li>不符合遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的；</p>",
        "<p><li style='float: left;'></li>含有法律、行政法规禁止的其他内容的。</p>",
        "<p>2.2 违反市场监管法律法规或规范性文件的内容</p>",
        "<p><li style='float: left;'></li>经市场监督管理等机关部门认定，发布内容涉嫌存在违反《广告法》《互联网广告管理暂行办法》等市场监管法律法规等规定的；</p>",
        "<p><li style='float: left;'></li>其他涉嫌违反市场监督管理的法律法规或规范性文件的。</p>",
        "<p>2.3 侵权、侵犯隐私权及原创争议类内容</p>",
        "<p>2.3.1 主体侵权</p>",
        "<p>擅自使用他人已经登记注册的企业名称或商标，侵犯他人企业名称专用权及商标专用权；擅自使用他人名称、头像，侵害他人名誉权、肖像权等合法权利。</p>",
        "<p>2.3.2 内容侵权</p>",
        "<p><li style='float: left;'></li>未经授权发送他人原创文章，侵犯他人知识产权。</p>",
        "<p><li style='float: left;'></li>未经授权发送他人身份证号码、照片等个人隐私资料，侵犯他人肖像权、隐私权等合法权益。</p>",
        "<p><li style='float: left;'></li>捏造事实公然丑化他人人格，或用侮辱、诽谤等方式损害他人名誉。</p>",
        "<p><li style='float: left;'></li>未经授权发送企业商业秘密，侵犯企业合法权益。</p>",
        "<p><li style='float: left;'></li>未经授权发布他人品牌商标信息等，侵犯他人知识产权。</p>",
        "<p><li style='float: left;'></li>通过帐号或利用相关帐号功能发布、传播假冒、盗版商品信息，推广、售卖假冒、盗版商品的行为。</p>",
        "<p><li style='float: left;'></li>为发布、传播假冒、盗版商品信息，推广、出售假冒、盗版商品提供协助或便利条件，如引流至销售假冒、盗版商品的第三方商城、第三方平台或其他外部网页等进行交易的行为。</p>",
        "<p><li style='float: left;'></li>使用和品牌方、版权方相同或相似的装潢、标识、商标，或通过自身资质的宣传，使用户误以为其为品牌方、版权方及其授权方的行为。</p>",
        "<p><li style='float: left;'></li>去除、隐藏、伪造品牌或版权作品的商标、标识等，或以其他方式恶意规避平台治理发布、传播假冒盗版商品信息或推广、出售假冒、盗版商品的行为。</p>",
        "<p><li style='float: left;'></li>假冒商品是指未经商标权人许可，使用与他人注册商标相同或相近似商标的商品；盗版商品是指未经版权方许可复制的图书、音像、美术作品和软件等。</p>",
        "<p>2.4 色俗内容</p>",
        "<p>2.4.1 散布淫秽、色情内容，包括但不限于招嫖、寻找一夜情、性伴侣等。</p>",
        "<p>2.4.2 发布有色情意味的情色文字、情色视频、情色漫画等内容。</p>",
        "<p>2.4.3 以投稿/爆料等形式描述约炮经历、性交体验、偷情、涉隐私部位偷拍等伤风败俗的话题内容。</p>",
        "<p>2.4.4 以低俗的配图引诱用户阅读文章。</p>",
        "<p>2.5 暴恐血腥内容</p>",
        "<p>2.5.1 散播人或动物被杀、致残以及枪击、刺伤、拷打等受伤情形的真实画面。</p>",
        "<p>2.5.2 出现描绘暴力或虐待儿童等内容。</p>",
        "<p>2.5.3 出现吸食毒品、自虐自残等令人不安的暴力画面内容。</p>",
        "<p>2.5.4 无资质销售仿真枪、弓箭、管制刀具、气枪等含有杀伤力枪支武器。</p>",
        "<p>2.5.5 出现以鼓励非法或鲁莽使用方式等为目的而描述真实武器的内容。</p>",
        "<p>2.5.6 出现事故现场、自杀现场、实验解剖等引起感观不适的血腥内容。</p>",
        "<p>2.6 赌博类内容</p>",
        "<p>发布组织聚众赌博、出售赌博器具、传授赌博（千术）技巧、方式、方法等内容、进行博彩活动、组织外围彩票或彩票预测服务等。</p>",
        "<p>2.7 危害平台安全内容</p>",
        "<p>发送钓鱼网站等信息，诱使用户上当受骗蒙受损失。</p>",
        "<p>发送病毒、文件、计算机代码或程序，可能对平台服务的正常运行造成损害或中断。</p>",
        "<p>2.8 涉黑类内容</p>",
        "<p>发送替人复仇、收账等具有黑社会性质的信息；雇佣、引诱他人从事恐怖、暴力等活动；拉帮结派，招募成员，对社会秩序构成潜在危害的内容。</p>",
        "<p>2.9 非法物品类内容</p>",
        "<p>包括但不限于买卖发票；出售假烟、假币、赃物、走私物品；违法办证刻章、代办身份证、信用卡、办理手机复制卡等信息；交易人体器官等内容。</p>",
        "<p>2.10 不实信息类内容</p>",
        "<p>2.10.1编造名人、明星、专家得绝症、去世或一些非常容易查证有违事实的内容。</p>",
        "<p>2.10.2过度解读或发布虚假的法律法规，政策内容。</p>",
        "<p>2.10.3编造、故意传播涉及食品安全、健康养生等日常生活、科学知识方面的不实消息。</p>",
        "<p>2.10.4发布其他类不实信息：经政府、媒体、法院等官方或权威机构认定，并公开说明属于不实信息的。</p>",
        "<p>2.11 宣扬封建迷信类内容</p>",
        "<p>以提供算命、冥婚、看相、取名、学业占卜、运势预测等具有封建迷信色彩类的服务作为噱头，发布转运消灾类商品等内容。</p>",
        "<p style='font-weight:bold;'>3 商标与商业外观规范</p>",
        "<p>3.1 账号必须遵守商标、版权等知识产权法律法规以及长光卫星关于知识产权使用的相关规则。</p>",
        "<p>3.2 非商标所有权人不得在账号中未经授权使用他人商标。</p>",
        "<p>3.3 使用他人商标、版权等涉及他人知识产权的内容需要与长光卫星官方取得联系，并根据要求提供相关权利证书或授权证明。</p>",
        "<p>3.4 非长光卫星官方帐号，禁止在帐号名称、输出内容中出现与长光卫星已有知识产权内容相同（如‘长光卫星’、‘吉林一号’、‘共生地球'等）的字样，或者容易与目前已有长光卫星产品设计主题、外观等相混淆的内容。</p>",
        "<p>3.5 任何误导和暗示长光卫星官方是该帐号运营者，或者误导和暗示长光卫星官方以任何形式表示认可其质量、服务或与其存在合作关系，而并非长光卫星公司运营的公众帐号将会被处理。</p>",
        "<p style='font-weight:bold;'>4 举报与处罚规范</p>",
        "<p>4.1 共生地球已启用用户举报处理机制，我们会根据用户的举报，视违规程度予以不同程度的处罚措施。使用过程中违反法律法规、《吉林一号·共生地球服务协议》等相关协议、规则的，遥感实验室账号可能被终止使用。</p>",
        "<p>4.2 对于涉嫌多次或经常编造、发布、转发、传播违法、违规信息内容的，或者涉嫌无正当理由频繁针对同一个或同一类型主体的合法权益进行不实或夸大的攻击或侵害的，或者已存在多项吉林一号·共生地球处理记录的账号，吉林一号·共生地球有权采取更为严厉的措施，包括但不限于对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号短期或永久封禁的处理，并有权拒绝再向该用户主体提供服务。</p>",
        "<p>4.3 如长光卫星因创作者的行为或相关因素受到用户投诉或举报的，创作者应当对于长光卫星处理用户投诉或举报予以充分配合，包括但不限于提供证明材料、履行说明义务等。</p>",

        "<p style='font-size:18px;font-weight:bold;'>四 遵守当地法律监管</p>",
        "<p>创作者在使用吉林一号·共生地球服务的过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。如果创作者的行为违反了当地法律法规或道德风俗，创作者应当为此独立承担责任。</p>",

        "<p style='font-size:18px;font-weight:bold;'>五 免责声明</p>",
        "<p>吉林一号·共生地球创作中心使用者明确了解并同意：</p>",
        "<p>关于吉林一号·共生地球创作中心服务长光卫星不提供任何种类的明示或暗示担保或条件，包括但不限于商业适售性、特定用途适用性等。你对吉林一号·共生地球创作中心的使用行为必须自行承担相应风险。</p>",
        "<p>吉林一号·共生地球创作中心使用者明确了解并同意，本创作规范是在保障遵守国家法律法规、维护公序良俗，以及保护他人合法权益的基础上，为打造绿色、健康、优质平台的更高目标而制定的，吉林一号·共生地球秉承该理念进行运营、管理和惩处规范，长光卫星在能力范围内尽最大的合理努力依照有效的法律法规做出判断，但是并不保证其判断完全与司法机构、行政机关的判断一致，为此产生的后果吉林一号·共生地球创作中心使用者已经理解并同意自行承担。</p>",

        "<p style='font-size:18px;font-weight:bold;'>六 动态文档</p>",
        "<p>本创作规范为动态文档，我们有权根据相关法律法规更新或产品运营的需要对其内容进行修改并更新，你应能反复查看以便获得最新信息。</p>",

        "<br />",

        "<p>吉林一号·共生地球创作中心</p>",

      ],

      document_imageUserAgreement:[
        "<p style='font-weight:bold;'>《吉林一号·共生地球影像授权服务协议》（以下简称 “本协议”）是长光卫星技术股份有限公司（以下简称“长光卫星”）与用户签订的影像使用授权许可协议，对用户使用吉林一号·共生地球提供的影像、视频、设计素材等产品（以下单独和统称为“内容”）的方式做出的规定。如果用户使用吉林一号·共生地球提供的内容，视为被授权人接受本协议的条款。</p>",
        "<p style='font-weight:bold;'>本协议视为《吉林一号·共生地球服务协议》、《吉林一号·共生地球隐私政策》的补充协议，是其不可分割的组成部分，与其构成统一整体。本协议与上述内容存在冲突的，以本协议为准。本协议内容包括本协议正文、吉林一号·共生地球已经发布和/或将来可能发布的与影像使用相关的各类规则。所有规则为本协议不可分割的组成部分，与本协议具有同等法律效力。一旦相关内容发生变动，吉林一号·共生地球将在相关页面提示您。如果您不同意对本协议内容所做的修改，则应立即停止使用吉林一号·共生地球相关影像服务；如果您继续使用，则视为您同意对本协议内容所做的修改。</p>",
        "<p style='font-size:18px;font-weight:bold;'>1 关于影像授权服务</p>",
        "<p>1.1 本服务是吉林一号·共生地球提供的影像内容授权使用服务，您须在同意本授权协议的基础上使用本服务，基于授权范围的不同，您对影像内容的使用、获取需支付不同数额的服务费用。此外，您也可以通过长光卫星认可的其他方式享有、使用本服务。</p>",
        "<p>1.2 吉林一号·共生地球可能会根据本服务的整体规划，对影像内容的服务收费标准、方式等进行修改和变更，前述修改、变更，吉林一号·共生地球将在相应服务页面进行展示。您若需要获取、使用本服务，请先提前明悉当时关于本服务的收费标准、方式等信息。</p>",
        "<p>1.3 基于虚拟产品的性质和特征，您所获取的虚拟产品不能够进行退货、换货、兑换现金，亦不得用于商业领域如买卖、置换、抵押等，法律另有强制性规定的除外。一切通过非官方公布渠道取得的虚拟产品及其衍生服务均不获得保护，吉林一号·共生地球有权中止或终止对您的服务。</p>",

        "<p style='font-size:18px;font-weight:bold;'>2 权利内容</p>",
        "<p style='font-weight:bold;'>基于影像内容授权范围的不同，长光卫星提供两种类型的授权模式：公开授权模式与付费授权模式。两种授权模式的授权说明如下：</p>",
        "<p>2.1公开授权模式：</p>",
        "<p>公开授权模式是长光卫星提供的吉林一号·共生地球影像内容的免费使用模式，在您未通过付费等长光卫星允许的方式获得影像内容的付费授权模式时，您对本服务提供的影像内容的使用均基于公开授权模式进行。公开授权模式下，本服务提供的影像内容的授权范围为：</p>",
        "<p>- 可创作。公开授权模式下，您可通过吉林一号·共生地球创作中心进行所有吉林一号·共生地球提供的影像内容的创作使用。</p>",
        "<p>- 可分享。您基于本服务提供的影像内容的创作可通过吉林一号·共生地球创作中心以转发、分享等方式发布至其他平台，但是您基于公开授权模式使用的授权内容，必须在该内容旁边加注下列信息：「素材来源 吉林一号·共生地球」。</p>",
        "<p>2.2付费授权模式</p>",
        "<p>付费授权模式是长光卫星提供的吉林一号·共生地球影像内容的付费使用模式，在您通过吉林一号·共生地球线上购买等长光卫星允许的方式获得影像内容的付费授权模式时，您对获得该授权模式的影像内容的使用基于付费授权模式进行。付费授权模式下，本服务提供的影像内容的授权范围为：</p>",
        "<p>- 可创作。付费授权模式下，您可通过吉林一号·共生地球创作中心进行所有吉林一号·共生地球提供的影像内容的创作使用。</p>",
        "<p>- 可分享。您基于本服务提供的影像内容的创作可通过吉林一号·共生地球创作中心以转发、分享等方式发布至其他平台，您基于付费授权模式使用的授权内容，无需署名信息来源。</p>",
        "<p>- 可下载。付费授权模式下，您可通过吉林一号·共生地球下载获得付费授权模式的影像内容的素材文件。</p>",
        "<p>- 可商用。付费授权模式下，您可对获得该授权模式的影像内容进行长光卫星允许的商业范围内的使用，包括：自媒体、电商宣传、网络推广、办公用途、线下活动。</p>",
        "<br />",
        "<p style='font-weight:bold;'>您需注意，您能够在不同授权模式的授权范围下，以任何本协议允许的方式使用影像内容（请参阅下列限制使用）。受限于该等限制和本协议的其余条款，长光卫星授予您的权利是：</p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>非永久有效的，这意味着您使用该内容的权利可能会根据本服务的整体规划而改变。基于用户需求变化，吉林一号·共生地球会不时修改、中断或终止无偿提供的服务，并可能视情况不会通知您且不承担相应责任。若服务变更影响您与长光卫星之间的有偿服务，长光卫星将在事先通知您（包括站内消息或者平台公告的方式）的情况下予以修改或中断。基于服务变更或终止带来的影响和后续事宜，您同意我们将按照公平公正、诚实信用、等价有偿的原则与您协商处理。详见赔偿/责任限制章节。</span></p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>非专属的，这意味着您没有使用内容的独家权利。长光卫星可以授权其他客户使用同一内容。</span></p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>无限的地域，这意味着您可以将内容使用于任何地域。</span></p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>就本协议而言，「使用」指复制、重制、修改、编辑、同步处理、执行、显示、广播、发布或以其他方式使用。</span></p>",
        "<p>请确保您阅读下列限制使用章节，以了解例外情况。</p>",

        "<p style='font-size:18px;font-weight:bold;'>3 授权限制使用条件</p>",
        "<p>您购买下载的影像内容不能进行如下操作：</p>",
        "<p>- 转售，不得转让或倒卖向第三方。</p>",
        "<p>- 将内容提供给他人或其他机构，企业下载。</p>",
        "<p>- 将内容的版权占据为自己版权。</p>",
        "<p>- 其他长光卫星禁止以及法律禁止的事项。</p>",
        "<p>- 不得非法使用。被授权人需遵守国家法律法规，不得以泄密、诋毁或其他任何非法形式或违反任何适用法规或行业规范的形式使用内容。</p>",
        "<p>- 不得对内容进行虚假陈述。被授权人不得虚假地声称内容来源。</p>",
        "<p>- 其他未经长光卫星许可的行为。</p>",

        "<p style='font-size:18px;font-weight:bold;'>4 法律适用和争议解决</p>",
        "<p>4.1 如果被授权人在任何社交媒体平台或其他第三方网站上使用内容，而该平台或网站为其自身目的使用或者以违反本协议的任何方式使用内容（或者宣布该等使用意图），则对于该等使用的授权立即终止，在此情况下，一经长光卫星要求，被授权人同意从该平台或网站上删除任何内容。</p>",
        "<p style='font-weight:bold;'>4.2 长光卫星可以在任何时候自主决定终止任何内容的授权。如果长光卫星通知或者被授权人获悉任何内容可能被指控侵犯任何第三方的权利，长光卫星可以要求被授权人立即停止使用该内容、删除或销毁任何复制件，因此引起的费用由被授权人自行承担。在符合本协议其他条款的前提下，长光卫星将免费向被授权人提供替换内容（具体由长光卫星根据其合理的商业判断确定）。</p>",
        "<p>4.3 由于不可抗力（包括但不限于地震、台风、洪水、火灾、战争、罢工、行政监管、法律法规和政策变更、电力和技术系统故障、黑客攻击等网络安全事故）等影响本协议有关条款履行的，在发生不可抗力期间，长光卫星可中止本协议的履行。</p>",
        "<p>4.4 本协议有关的任何纠纷或争议应通过友好协商解决，如不能协商解决，任何一方可提交仲裁委员会进行仲裁，仲裁决定对双方均有约束力，本协议适用中华人民共和国法律管辖。</p>",

        "<p style='font-size:18px;font-weight:bold;'>5 赔偿/责任限制</p>",
        "<p style='font-weight:bold;'>5.1 被授权人对长光卫星的赔偿。被授权人同意赔偿长光卫星因下列原因引起或与之相关的所有损害、赔偿责任和费用（包括合理的外部律师费）：</p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>被授权人在本协议允许的范围之外使用内容；</span></p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>被授权人或代表被授权人行事的任何人违反或被指称违反本协议或与长光卫星签订的任何其他协议的任何条款；</span></p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>被授权人未取得对于被授权人使用内容必要的任何许可。</span></p>",
        "<p style='font-weight:bold;'>5.2 长光卫星对被授权人的赔偿。在被授权人未违反本协议或与长光卫星签订的任何其他协议的情况下，长光卫星若因自身原因致使被授权人获取的授权内容发生下架、无法使用等问题情况，长光卫星为确保被授权人免遭损害，将依照本条规定，赔偿被授权人等价的授权内容。本赔偿保证不适用于因被授权人修改内容或被授权人使用内容的场景引起或导致的任何损害、费用或损失。如果在长光卫星通知或者被授权人获悉任何内容被指控侵犯任何第三方的权利后，被授权人继续使用该内容的，同样不适用本赔偿保证。</p>",
        "<p style='font-weight:bold;'>5.3 吉林一号·共生地球仅为用户提供地图类资源获取、分享、创作及传播的平台，用户必须为自己注册的帐号下的一切行为负责，包括用户授权内容的使用方式以及由此产生的任何后果。用户须知，由于遥感影像信息及各类地图信息的特殊性，用户应对本服务中的授权内容及使用方式自行加以判断，并承担因使用内容而引起的所有风险，包括因对授权内容的正确性、完整性或实用性而产生的风险。长光卫星无法且不会对因前述风险而导致的任何损失或损害承担责任。</p>",
        "<p style='font-weight:bold;'>5.4 用户须知，在使用本服务时，须自行承担如下长光卫星不可掌控的风险内容，长光卫星无法保证对因该内容致使的损害进行赔偿。不可掌控的内容包括但不限于：</p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>由于受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏等不可抗拒因素可能引起的信息丢失、泄漏等损失和风险；</span></p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>用户或长光卫星的电脑软件、系统、硬件和通信线路出现故障导致的服务终端、数据丢失以及其他的损失和风险；</span></p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>用户操作不当或通过非长光卫星授权的方式使用本服务带来的损失和风险；</span></p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>用户发布的内容被他人转发、分享，因此等传播可能带来的风险和责任；</span></p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>由于网络信号不稳定等原因，所引起的吉林一号·共生地球登录失败、资料同步不完整、页面打开速度慢等风险；</span></p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>不可抗力等风险因素：不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、风暴等以及社会事件如战争、动乱、政府行为等。</span></p>",
        "<p><li style='float: left;'></li><span style='font-weight:bold;'>其他长光卫星无法控制或合理预见的情形。</span></p>",

        "<p style='font-size:18px;font-weight:bold;'>6 知识产权</p>",
        "<p>6.1除长光卫星另有特别提示的以外，所有授权内容的知识产权均归长光卫星所有，本协议中没有明文授予的所有权利皆由长光卫星保留。</p>",
        "<p>您理解并同意，使用本产品或服务发布、上传的文字、 图片、视频、音频等必须由您原创或已获合法授权。您通过本产品和/或服务上传、发布的任何内容的知识产权归您或原始著作权人所有。</p>",
        "<p>6.2您知悉、理解并同意，您使用本服务授权内容创作、发布、传输或传播内容(包括但不限于文字、图片、图像、音频、视频和/或音频中的音乐、声音、对话等)，即表明您有权且同意授权长光卫星及或关联公司、控制公司、承继公司一项全球范围内、永久性的、不可撤销的、免费、非独家、可再许可(通过多层次)的权利(包括但不限于复制权、信息网络传播权、改编权、汇编权、修改权、翻译权、制作衍生品、表演和展示等权利)，使用范围包括但不限于当前或其他网站、应用程序、产品或终端设备等。您在此确认并同意，上述权利的授予包括在内容、长光卫星或长光卫星品牌有关的任何的宣传、推广、广告或相关营销中使用和以其他方式开发内容(全部或部分)的权利和许可。</p>",
        "<p>6.3若您认为长光卫星或第方利用本产品或服务侵犯了您的合法权益，您可以以书面方式向长光卫星提交权利通知及相关的支持性资料，长光卫星将会依据法律法规的要求和《权利保护声明》(作为本协议的附属协议) 进行处理。您理解并同意，如果您提供的权利通知的陈述失实，您将承担由此造成的全部损失(包括但不限于赔偿长光卫星及/或关联方、控制公司、承继公司因此而支付的罚款、赔偿金、诉讼费、律师费、公证费、鉴定费、保全费、调查证据费用等各种费用)。如果您对该等侵权行为并无确信，建议先行咨询专业人士。</p>",

        "<p style='font-size:18px;font-weight:bold;'>7 一般性条款</p>",
        "<p>7.1 转让。本协议与被授权人签订，未经长光卫星事先书面同意，被授权人不得转让本协议。长光卫星可以将本协议转让给任何关联公司或权益承继人，无需事先通知或取得被授权人的同意，前提是该实体同意受本协议条款的约束。</p>",
        "<p>7.2 审核。在长光卫星合理通知被授权人的前提下，被授权人同意向长光卫星提供包含授权内容的项目或最终用途的复制件样品，包括允许长光卫星免费登录复制内容的任何设置付费壁垒或其他登陆限制的网站或平台。此外，在发出合理通知后，长光卫星可以自主决定委托其员工或第三方审核被授权人与本协议和授权内容的使用直接相关的记录，以核实被授权人遵守本协议条款的情况。如果任何审核显示被授权人少付给长光卫星的款项达到被授权人本应支付的款项金额的百分之五(5%)或以上，除向长光卫星支付该少付款项和在不妨碍长光卫星拥有的任何其他救济的情况下，被授权人同意向长光卫星偿付该审核的费用。</p>",
        "<p>7.3 电子存储。被授权人同意在储存及传送内容时保留内容识别符和包含原始内容的电子文件中的任何其他信息或数据，以及采取合适的保密措施，防止未经授权的第三方使用内容。</p>",
        "<p>7.4 本协议应根据中华人民共和国法律解释、理解和管辖。双方之间就本协议产生的或与本协议有关的任何争议、争论或索赔，或本协议的违反、终止或无效应由双方友好协商解决。如果双方不能够在协商开始后三十(30)日内达成一致，则任何一方有权将事项提交长光卫星住所地有管辖权的人民法院诉讼解决。</p>",
        "<p>7.5 可分割。本协议的一条或多条规定在任何方面被认定无效、不合法或不能强制执行的情况下，本协议其他规定的有效性、合法性和可强制执行性不受影响。对于该等无效规定，应在必要的范围内进行修订，使其能够强制执行。</p>",
        "<p>7.6 弃权。除非提供明确的书面弃权声明，否则不得将任何一方的任何行动理解为对本协议的任何条款的放弃。</p>",
        "<p>7.7 完整协议。长光卫星有权随时增加或删除本协议的任何条款或条件。本协议的条款与被授权人发出的任何购买订单、双方签订的其他书面协议中包含的条款之间存在任何冲突的，以具体购买订单、协议的条款为准；其他协议未涉及的，以本协议的条款为准。</p>",
        "<p>7.8 税收。被授权人同意缴纳和承担因提供给被授权人的授权许可或被授权人使用授权内容而在任何司法管辖区被征收的任何及所有销售税、使用税、增值税、预扣税和关税。</p>",

      ]






    }

  },

  methods:{
    getDocument(){
      switch(this.$route.query.pageType){
        case "privacy":{
          this.pageName = "吉林一号·共生地球隐私政策";
          this.pageDocument = this.document_privacy;
          break;
        }
        case "userAgreement":{
          this.pageName = "吉林一号·共生地球服务协议";
          this.pageDocument = this.document_userAgreement;
          break;
        }
        case "createAgreement":{
          this.pageName = "吉林一号·共生地球创作中心创作规范";
          this.pageDocument = this.document_createAgreement;
          break;
        }
        case "imageUserAgreement":{
          this.pageName = "吉林一号·共生地球影像授权服务协议";
          this.pageDocument = this.document_imageUserAgreement;
          break;
        }


      }


    }

  },

  mounted(){
    this.getDocument();
  }
}
</script>

<style scoped>

.documentArea{
  margin-top:20px;
}
/*.documentArea p{*/
/*  margin-bottom:10px !important;*/
/*}*/

</style>